module.exports = __webpack_public_path__ + "static/media/car-6.305be4c7.jpg";